module.exports = __webpack_public_path__ + "img/xiaohe1.d24fd1d5.png";